import { Contact } from "./contact";
import { AttendanceType, ValidityStatus } from "./enums";
import { EventType } from "./event-type";
import { Project } from "./project";
import { TopicOfInterest } from "./topic-of-interest";

export class AppEvent {
  id!: number;
  name!: string;
  description?: string;
  eventTypes: EventType[] = [];
  date!: string; // ISO date string (e.g., '2025-09-29')
  endDate?: string | null;
  attendanceType?: AttendanceType;
  responsiblePerson?: string;
  topics: TopicOfInterest[] = [];
  projects: Project[] = [];
  driveFolder?: string;
  website?: string;
  addedBy?: string;
  contacts: Contact[] = [];

  lastModifiedBy?: string | null;
  lastModifiedOn?: string | null;

  constructor(init?: Partial<AppEvent>) {
    Object.assign(this, init);
  }

  // isValid(): boolean {
  //   return !!(this.name && (this.eventTypes && this.eventTypes.length > 0) && this.responsiblePerson);
  // }

  validityStatus(): ValidityStatus {
    if (!(this.name && this.responsiblePerson && ((this.eventTypes?.length ?? 0) > 0))) {
      return ValidityStatus.INVALID;
    } else if (!(this.description)) {
      return ValidityStatus.INCOMPLETE;
    } else {
      return ValidityStatus.VALID;
    }
  }
}
